import { gql } from '@apollo/client';

export const CREATE_QUESTIONS_ANSWERS = gql`
  mutation create_questions_answers($data: CreateQuestionsAnswersInputType) {
    create_questions_answers(data: $data) {
      hasError
      data
      message
    }
  }
`;

export const LIST_MEDIA = gql`
  query list_media($data: ListMediaInputType) {
    response: list_media(data: $data) {
      hasError
      data
      message
    }
  }
`;
